module.exports = __webpack_public_path__ + "img/logo.2e75cc0e.png";